import { actions } from './actions';

const INITIAL_STATE = {
  slides: [],
  currentSlide: {},
  loading: true,
  uploading: false,
};

export default function illustrationReducer(
  state = INITIAL_STATE,
  { type, payload },
) {
  switch (type) {
    case actions.RESET:
      return INITIAL_STATE;
    case actions.SLIDES_SUCCESS:
      return { ...state, slides: payload };
    case actions.SLIDE_SUCCESS:
      return { ...state, currentSlide: payload };
    case actions.TOGGLE_LOADING:
      return { ...state, loading: payload };
    case actions.UPLOADING:
      return { ...state, uploading: payload };
    default:
      return state;
  }
}
